import {
  commonThunkCondition,
  fulfilledThunkState,
  initialThunkState,
  pendingThunkState,
  rejectedThunkState,
} from "@duosoftbg/nacid-components";
import { AsyncThunk, createAsyncThunk, createSlice, Slice } from "@reduxjs/toolkit";

const createAppDataSliceAndThunk = (
  name: string,
  loadFunction: () => () => Promise<any>,
): [AsyncThunk<any, void, {}>, Slice] => {
  const sliceName = `appData/${name}`;

  const asyncThunk = createAsyncThunk(
    `${sliceName}/${sliceName}Thunk`,
    async () => {
      const response = await loadFunction()();
      return response;
    },
    {
      condition: (_, { getState, extra }) => {
        return commonThunkCondition(getState()["AppData"]?.[name]);
      },
    },
  );

  const slice = createSlice({
    name: sliceName,
    initialState: initialThunkState([]),
    reducers: {},
    extraReducers: (builder) => {
      builder.addCase(asyncThunk.pending, (state, action) => {
        return pendingThunkState(state);
      });
      builder.addCase(asyncThunk.fulfilled, (state, action) => {
        const data = action.payload;
        return fulfilledThunkState(data);
      });
      builder.addCase(asyncThunk.rejected, (state, action) => {
        return rejectedThunkState([]);
      });
    },
  });

  return [asyncThunk, slice];
};

export default createAppDataSliceAndThunk;
